import { useMemo } from "react"
import { IFeature } from "interfaces"
import { TITLE, DESCRIPTION } from "./data"
//TODO:: add logic to this hook later

interface IUseEmBenchasiriResult {
  title: string
  description: string
  events: IFeature[]
}

type UseEmBenchasiri = (
  feature: IFeature,
  events: IFeature[],
  option?: object
) => IUseEmBenchasiriResult

export const useEmBenchasiri: UseEmBenchasiri = (
  feature,
  events = [],
  options = {}
): IUseEmBenchasiriResult => {
  const benchasiriEvents = useMemo(
    () =>
      feature
        ? events.filter(
            (event) => event?.properties?.feature?.id === feature?.id
          )
        : [],
    [events, feature]
  )

  return {
    title: TITLE,
    description: DESCRIPTION,
    events: benchasiriEvents,
  }
}
